import { Component, OnInit } from '@angular/core';
import { ResultList } from 'app/models';
// import { CustomerEmployeeTrackingService } from 'app/services';

@Component({
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html'
})
export class NavbarNotificationComponent implements OnInit {
  // public customerEmployeeTrackingResultList: ResultList<CustomerEmployeeTrackingResult>;

  // constructor(private customerEmployeeTrackingService: CustomerEmployeeTrackingService) {
  //   this.customerEmployeeTrackingResultList = new ResultList<CustomerEmployeeTrackingResult>();
  // }

  ngOnInit(): void {
    // const getCustomerEmployeeTrackingsInput = new GetCustomerEmployeeTrackingsInput();
    // getCustomerEmployeeTrackingsInput.GetNotifications = true;
    // getCustomerEmployeeTrackingsInput.paginationInformation.ItemsPerPage = 5;
    // this.customerEmployeeTrackingService.getCustomerEmployeeTrackings(getCustomerEmployeeTrackingsInput).then(result => {
    //   if (result.Success == true) {
    //     this.customerEmployeeTrackingResultList = result;
    //   }
    // });
  }
}
